import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

import { BubbleData, BubbleDataSet } from "../../charts/bubble-chart/bubble-chart.component";
import { InsightsFieldType } from "../../insights/model/insights-field-type";
import { getInsightsWithoutCreate, Linqset } from "../../common/linqset-model";
import { NODE_TYPE_DATA_TYPE, NodeTypeData } from "../node-types/node-type-data";

@Component({
    selector: 'app-node-bubble-chart',
    templateUrl: './node-bubble.html',
    standalone: false
})
export class NodeBubbleComponent implements OnInit, OnChanges {
    @Input() trigger:any
    @Input() typeData:NodeTypeData
    @Input() linqset:Linqset

    @Input() fieldTypes:InsightsFieldType[]
    
    @Output() selectNodeEvent = new EventEmitter<string>(); 
    
    loading:boolean = false
    maxValue:number = 0
    data: BubbleDataSet
    labels:string[]
    
    constructor(private changeDetectorRef:ChangeDetectorRef) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["trigger"] || changes["typeData"] || changes["fieldTypes"]) { 
            this.loading = true
            this.changeDetectorRef.detectChanges()
            setTimeout(() => {
                try {
                    this.populateData()
                } finally {
                    this.loading = false
                }
            }, 0)

        }
    }

    ngOnInit(): void {
        this.populateData()
    }

    populateData() {
        this.maxValue = 0
        this.data = new BubbleDataSet(this.typeData.name, this.typeData.colour, this.typeData.hoverColour, [])
        this.labels = this.fieldTypes.map(t => t.type.toString())

        if (this.typeData.dataType === NODE_TYPE_DATA_TYPE.MODELS) {
            this.data.data = this.typeData.models.map(m => {
                const insights = m.insights.find(i => i.projectKey === this.fieldTypes[2].workspaceKey)
                const z = this.fieldTypes[2].getSingleValueFromInsights(insights, this.typeData.dataType)
                if (this.maxValue < z) this.maxValue = z
                return new BubbleData(m._key, m.name, this.fieldTypes[0].getSingleValueFromInsights(insights, this.typeData.dataType), this.fieldTypes[1].getSingleValueFromInsights(insights, this.typeData.dataType), z)
            })
        }else if (this.typeData.dataType === NODE_TYPE_DATA_TYPE.GROUP) {
            this.data.data = this.typeData.groups.filter(gd => gd.insights).map(gd => {
                const z = this.fieldTypes[2].getSingleValueFromInsights(gd.insights, this.typeData.dataType)
                if (this.maxValue < z) this.maxValue = z
                return new BubbleData(gd._key, gd.name, this.fieldTypes[0].getSingleValueFromInsights(gd.insights, this.typeData.dataType), this.fieldTypes[1].getSingleValueFromInsights(gd.insights, this.typeData.dataType), z)
            })
        }else {
            this.data.data = this.typeData.list.filter(nd => !nd.excluded).map(nd => {
                // in the whole organisation, actions and information keep the insights of their model
                const insights = getInsightsWithoutCreate(nd, this.linqset)
                const z = this.fieldTypes[2].getSingleValueFromInsights(insights, this.typeData.dataType)
                if (this.maxValue < z) this.maxValue = z

                return new BubbleData(nd._key, nd.name, this.fieldTypes[0].getSingleValueFromInsights(insights, this.typeData.dataType), this.fieldTypes[1].getSingleValueFromInsights(insights, this.typeData.dataType), z)
            })
        }
    }

    hideChart() {}

    onSelect(event): void {
        this.selectNodeEvent.emit(event)
    }    
}
